<template>


    <nav v-if='$root.loaded && $root.user && $root.lookup.user_roles' class="left-navbar col-3 h-100" style="width: 100%;" :class="{ open: menuActive }">
        <div class="left-nav-toggle" @click="menuActive = !menuActive"><span class="hamburger"></span></div>

        <div class="d-flex flex-column h-100" style="width: 100%;">
            <div class="nav-brand">
                <div class="p-2 brand-logo">
                    <!-- <img src="/img/askmygp-logo-white.png"> -->
                </div>

                <div class="pl-2 pr-2 pb-1 pt-1 nav-brand-organisation">
                    <template v-if='this.$root.user.user_provider.length > 1'>
                        <label for="select-provider" class="sr-only">Select Provider</label>
                        <select id="select-provider" v-on:change='$root.switchProvider($event)' class='form-control custom-select' v-model='$root.user.provider.id'>
                            <option v-for='provider in $root.user.user_provider.slice(0).sort((a,b) => {return a.name.localeCompare(b.name)})' :value='provider.id' :key='provider.id'>{{provider.name}}</option>
                        </select>
                        <div class='text-center' v-text='isServiceAvailable() ? "" : "(Offline)"'></div>
                    </template>
                    <template v-else>
                        <span v-text='$root.user ? $root.user.provider.name : ""'></span>
                        <span v-text='isServiceAvailable() ? "" : "(Offline)"'></span>
                    </template>
                </div>
            </div>

            <div class='pt-2 h-100 flex-grow-1-scroll' v-on:click="toggleActiveNav">

                <ul v-if='$root.user && $root.user.id' class="list-group">

                    <router-link to="/home" tag="li" class="nav">
                        <a>
                            <i class="icon icon-md icon-home"></i>
                            <span>{{ $t('translations.home') }}</span>
                        </a>
                    </router-link>

                    <router-link to="/dashboard" tag="li" class="nav">
                        <a>
                            <i class="icon icon-md icon-dashboard"></i>
                            <span>{{ $t('translations.dashboard') }}</span>
                        </a>
                    </router-link>
                    <li class='nav-separator'>&nbsp;</li>
                    <template v-if='!is_network_admin()'>
                        <!-- Testing the new request submenu -->
                        <!-- <li data-navname='requests' v-on:click.stop="toggleActiveNav" :class="'nav ' + isActive('requests')">
                            <router-link to="/thread-list" tag="a" class="nav">
                                <i class="icon icon-md icon-requests"></i>
                                <span>{{ $t('translations.requests') }}</span>
                            </router-link>
                            <ul v-on:click.stop>
                                <router-link to="/thread-list-failed" tag="li" class="nav">
                                    <a>
                                        <i class="icon icon-md icon-requests"></i>
                                        <span>{{ $t('translations.requests') }}</span>
                                    </a>
                                </router-link>
                            </ul>
                        </li> -->
                        <router-link to="/thread-list" tag="li" class="nav">
                            <a data-testid='nav-view-requests' >
                                <i class="icon icon-md icon-requests"></i>
                                <span class='d-flex flex-row'>
                                    <span class='m-0'>{{ autobrand('translations.requests_title') | capitalise }}</span>
                                    <span class='m-0 flex-grow-1 text-right'>
                                        <span v-if='currentRequestCount' class="m-0 nav-badge">
                                            {{ currentRequestCount > 99 ? "99+" : currentRequestCount }}
                                        </span>
                                    </span>
                                </span>
                            </a>
                        </router-link>

                        <!-- $root.user && $root.user.email.match("@redpixelyellowpixel|@evergreen-life|@salvie|@gpaccess.uk") -->
                        <li v-if='$root.provider && $root.provider.campaigns_enabled' data-navname='patients' v-on:click.stop="setActiveNav" :class="'nav ' + isActive('patients')">
                            <router-link to="/patient-list" tag="a" class="nav">
                                <i class="icon icon-md icon-patients"></i>
                                <span>{{ tBrandKey('clients') | capitalise }}</span>
                                <span class="icon-arrow-down icon-small"></span>
                            </router-link>
                            <ul v-on:click.stop>
                                <router-link to="/cohort-list" tag="li" class="nav">
                                    <a>
                                        <i class="icon icon-md icon-groups"></i>
                                        <span>{{ $t('translations.cohorts') | capitalise }}</span>
                                    </a>
                                </router-link>
                            </ul>
                            <ul v-on:click.stop>
                                <router-link to="/campaign-list" tag="li" class="nav">
                                    <a>
                                        <i class="icon icon-md icon-fa fa fa-lg fa-bullseye"></i>
                                        <span>{{ $t('translations.campaigns') | capitalise }}</span>
                                    </a>
                                </router-link>
                            </ul>
                            <ul v-on:click.stop>
                                <router-link to="/userduplicate-list" tag="li" class="nav">
                                    <a>
                                        <i class="icon icon-md icon-patients"></i>
                                        <span>{{ $t('translations.manage_duplicates') }}</span>
                                    </a>
                                </router-link>
                            </ul>
                        </li>

                        <router-link v-else to="/patient-list" tag="li" class="nav">
                            <a>
                                <i class="icon icon-md icon-patients"></i>
                                <span>{{ tBrandKey('clients') | capitalise }}</span>
                            </a>
                        </router-link>

                        

                        <router-link v-if='appointmentsEnabled()' to="/appointments" tag="li" class="nav">
                            <a>
                                <i class="icon icon-md icon-calendar"></i>
                                <span>{{ $t('translations.appointments') }}</span>
                            </a>
                        </router-link>

                        <router-link to="/staff-list" tag="li" class="nav">
                            <a>
                                <i class="icon icon-md icon-staff"></i>
                                <span>{{ $t('translations.staff') }}</span>
                            </a>
                        </router-link>

                        <li class='nav-separator'>&nbsp;</li>
                    </template>


                    <li data-navname='profile' v-on:click.stop="toggleActiveNav" :class="'nav ' + isActive('profile')">
                        <a >
                            <i class="icon icon-settings"></i>
                            <span>{{ $t('translations.settings') }}</span>
                            <span class="icon-arrow-down icon-small"></span>
                        </a>
                        <ul v-on:click.stop>
                            <router-link to="/staff-profile" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-profile"></i>
                                    <span>{{ $t('translations.my_profile') }}</span>
                                </a>
                            </router-link>
                            <router-link to="/presetmessage-list" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-preset-message-white"></i>
                                    <span>{{ $t('translations.preset_messages') }}</span>
                                </a>
                            </router-link>
                            <router-link to="/usergroup-list" v-if='is_superuser() || is_admin()' tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-groups"></i>
                                    <span>{{ $t('translations.groups') }}</span>
                                </a>
                            </router-link>
                            <router-link to="/tag-list" v-if='is_superuser() || is_admin()' tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-fa fa fa-lg fa-tags"></i>
                                    <span>{{ $t('translations.tags') | capitalise }}</span>
                                </a>
                            </router-link>
                            <router-link to="/custom_action-list" v-if='is_superuser() || is_admin()' tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-fa fa fa-lg fa-grip-lines"></i>
                                    <span>{{ $t('translations.custom_actions') | titleCase }}</span>
                                </a>
                            </router-link>
                            <router-link to="/capacity-planning" v-if='is_superuser() || is_admin()' tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-capacity-planning"></i>
                                    <span>{{ titleCase($t('translations.capacity_planning')) }}</span>
                                </a>
                            </router-link>
                            <router-link to="/settings" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-provider"></i>
                                    <span>{{ $t('translations.system') }}</span>
                                </a>
                            </router-link>
                            <router-link to="/lab" v-if='is_superuser() && $root.user.id == 1' tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-lab"></i>
                                    <span>Tests</span>
                                </a>
                            </router-link>
                            <router-link to="/log-list" v-if='is_superuser()' tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-log"></i>
                                    <span>{{ $t('translations.system_logs') }}</span>
                                </a>
                            </router-link>
                            <!-- <router-link to="/filing-list" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-fa fa fa-lg fa-copy"></i>
                                    <span>{{ $t('translations.failed_filings') }}</span>
                                </a>
                            </router-link> -->
                            <router-link to="/diagnostics" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-diagnostic"></i>
                                    <span class="icon-alert icon-disabled">!</span>
                                    <span>{{ $t('translations.diagnostics') }}</span>
                                </a>
                            </router-link>
                            <!-- <router-link to="/userduplicate-list" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-patients"></i>
                                    <span>{{ autobrand('translations.duplicate_patients') }}</span>
                                </a>
                            </router-link> -->
                        </ul>

                    </li>

                    <router-link to="/news-list" v-if='is_network_admin()' tag="li" class="nav">
                        <a>
                            <i class="icon icon-md icon-settings"></i>
                            <span>{{ $t('translations.news') }}</span>
                        </a>
                    </router-link>

                    <router-link v-if='$root.provider && $root.provider.reports_enabled' to="/reports" tag="li" class="nav">
                        <a>
                            <i class="icon icon-md icon-reports"></i>
                            <span>{{ $t('translations.reports') }}</span>
                        </a>
                    </router-link>

                    <router-link to="/filing-list" tag="li" class="nav">
                        <a>
                            <i class="icon icon-md icon-fa fa fa-lg fa-copy"></i>
                            <span class='d-flex flex-row'>
                                <span class='m-0'>{{ $t('translations.failed_filings') }}</span>
                                <span class='m-0 flex-grow-1 text-right'>
                                    <span v-if='failedFilingCount' class="m-0 nav-badge-danger">
                                        {{ failedFilingCount > 99 ? "99+" : failedFilingCount }}
                                    </span>
                                </span>
                            </span>
                        </a>
                    </router-link>



                    <!-- <router-link to="/isabel" tag="li" class="nav">
                        <a>
                            <i class="icon icon-md icon-isabel"></i>
                            <span>Isabel</span>
                        </a>
                    </router-link> -->

                    <li class='nav-separator'>&nbsp;</li>

                    <!-- <li class="nav" v-if='getHelpLink()'>
                        <div ref='helpLauncher' class='w-100' data-nickelled-launcher="custom" :data-guide="getDataGuide">
                                <i class="icon icon-md icon-help"></i>
                                <span>{{ $t('translations.guide') }}</span>
                        </div>
                    </li>
                    <li class="nav" v-else>
                        <a :href="'#'" v-on:click='showNoHelp()'>
                            <i class="icon icon-md icon-help"></i>
                            <span>Help</span>
                        </a>
                    </li>-->
                    <router-link v-if='$root.provider && $root.provider.reports_enabled' to="/feedback-list" tag="li" class="nav">
                       <a>
                           <i class="icon icon-md icon-feedback-patient"></i>
                           <span>{{ autobrand('translations.patient_feedback') }}</span>
                       </a>
                   </router-link>
                    <!-- <li data-navname='feedback' v-on:click.stop="toggleActiveNav" :class="'nav ' + isActive('feedback')">
                        <a >
                            <i class="icon icon-feedback"></i>
                            <span>{{ $t('translations.feedback') }}</span>
                            <span class="icon-arrow-down icon-small"></span>
                        </a>
                        <ul v-on:click.stop>
                             <li class="nav">
                                <a :href="'https://askmygp.formstack.com/forms/askmygp_user_report?name='+this.$root.user.forenames+'%20'+this.$root.user.surname+'&email='+this.$root.user.email+'&organisation='+this.$root.user.provider.name" target="_blank">
                                    <i class="icon icon-md icon-feedback-send"></i>
                                    <span>{{ $t('translations.send_feedback') }}</span>
                                </a>
                             </li>
                             <router-link to="/feedback-list" tag="li" class="nav">
                                <a>
                                    <i class="icon icon-md icon-feedback-patient"></i>
                                    <span>{{ autobrand('translations.patient_feedback') }}</span>
                                </a>
                            </router-link>

                        </ul>
                    </li> -->
                </ul>
            </div>

            <div class="nav-brand nav-brand-footer text-center mt-auto d-flex flex-column p-2">

                <div class="d-flex justify-content-center">
                    <div class="col-8  helpdesk-widget"  v-on:click.prevent='$root.freshdeskShowWidget()'>{{ $t('translations.help')}}</div>
                    <template v-if="tBrandKey('training_link')">
                        <div class="helpdesk-widget">|</div>
                        <div class="col-8 helpdesk-widget"><a class='nav' target="app_training" :href="tBrandKey('training_link')">{{ $t('translations.training') | capitalise}}</a></div>
                    </template>
                </div>
                <span class="p-2">{{formatName(this.$root.user)}}</span>
                <template v-if="$root.isLoggedIn()">
                    <div>
                        <a href="/logout/2" class="btn btn-light btn-round text-center">{{ $t('translations.logout') }}</a>
                    </div>
                </template>
            </div>
        </div>
    </nav>



</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
            subNavActive: undefined,
            helpLinks: {'dashboard': 'dashboard'},
            currentHelpLink: "",
            locale: window.default_locale,
            menuActive: false
        };
    },
    computed: {
        // hasHelpLink() {
        //     return this.getHelpLink();
        // },
        // getDataGuide() {
        //     if(this.$refs.helpLauncher) {
        //         //this.$refs.helpLauncher.outerHTML = this.$refs.helpLauncher.outerHTML;
        //         this.$refs.helpLauncher.removeAttribute("data-activated");
        //     }
        //     //alert("Computing help link: " + this.$route.path);
        //
        //     var helpLink = this.getHelpLink();
        //
        //     if(this.currentHelpLink != helpLink) {
        //         this.currentHelpLink = helpLink;
        //
        //         Vue.nextTick(() => {
        //             this.showNickelled();
        //         });
        //     }
        //
        //     return helpLink;
        // }
        currentRequestCount() {
            return this.$root.requests.filter(obj => {
                return !obj.closed_at && obj.thread_provider && !obj.thread_provider.waiting_until
                        && this.new_message(obj)}).length;
        },
        failedFilingCount() {
            return this.$root.failed_filing_count;
        },
    },
    mounted() {
        
    },
    methods: {
        isActive(name) {
            return this.subNavActive == name ? "active" : "";
        },
        toggleActiveNav(event) {
            if(event.currentTarget.dataset["navname"]) {
                this.subNavActive === event.currentTarget.dataset["navname"] ? this.subNavActive = null : this.subNavActive = event.currentTarget.dataset["navname"];
            }
            else {
                this.subNavActive = null;
            }
        },
        setActiveNav(event) {
            this.subNavActive = event.currentTarget.dataset["navname"];
            // if(!this.isActive(event.currentTarget.dataset["navname"])) {
            //     this.subNavActive = event.currentTarget.dataset["navname"];
            // }
            // else {
            //     this.toggleActiveNav(event);
            // }
        },
        // getHelpLink() {
        //     var parts = this.$route.path.split("/");
        //
        //     while(parts.length > 1 && parts[parts.length - 1].match(/[0-9]/)) {
        //         parts.pop();
        //     }
        //
        //     if(parts.length > 1
        //          // && this.helpLinks[parts[parts.length - 1]]
        //          ) {
        //         //return "https://askmygp.nickelled.com/" + this.helpLinks[parts[parts.length - 1]];
        //         return "https://askmygp.nickelled.com/" + parts[parts.length - 1];
        //     }
        //     return false;
        // },
        // showNoHelp() {
        //     this.$modal.show('dialog', {
        //         title: 'Help',
        //         text: "No help available for this page.",
        //         buttons: [
        //         {
        //             title: 'Close',
        //             default: true
        //         }]});
        // },
        setLocale() {
            Vue.nextTick(() => {
                this.$root.setLocale(this.locale);
            });
        },

        is_unread(item) {
            if(!item.user_thread_read_status) {
                return true;
            }
            if(item.latest_message != null && typeof item.latest_message == "object" && item.latest_message.created_at > item.user_thread_read_status.read_at) {
                return true;
            }
            return false;
        },
        new_message(item) {
            if(item.thread_provider 
                    && (
                        this.is_assignedToMe(item) 
                        || this.is_assignedToMyGroups(item) 
                        || this.is_unassigned(item))) {
                return this.is_unread(item);
            }
            return false;
        },
        is_unassigned(item) {
            if((!item.thread_provider.assigned_user_id && !item.thread_provider.assigned_group_id)) {
                return true
            }
            return false;
        },
        is_assignedToMe(item) {
            if(item.thread_provider.assigned_user_id == this.$root.user.id) {
                return true
            }
            return false;
        },
        is_assignedToMyGroups(item) {
            if(item.thread_provider.assigned_group_id) {
                return this.$root.user.user_group.filter(obj => {
                    return item.thread_provider.assigned_group_id == obj.user_group_id;
                }).length;
            }
            return false;
        },

    }
}
</script>

<style>
.navbar-expand-lg {
    padding: 0;
}
</style>
